document.addEventListener('DOMContentLoaded', function () {

  const MAX_QTY = 5;

  function toggleButtons() {
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const qty = parseInt(qtyInput.value || 1);

    const addToCartBtn = document.querySelector('form[action="/cart/add"] button[type="submit"]');
    const buyNowBtn = document.querySelector('.shopify-payment-button');
    const stickyATC = document.querySelector('.sticky-atc, .sticky-add-to-cart, [data-sticky-atc]');
    const quoteBtn = document.querySelector('.sk-quote-btn, .sk-request-quote');

    if (qty > MAX_QTY) {
      if (addToCartBtn) addToCartBtn.style.display = 'none';
      if (buyNowBtn) buyNowBtn.style.display = 'none';
      if (stickyATC) stickyATC.style.display = 'none';
      if (quoteBtn) quoteBtn.style.display = 'block';
    } else {
      if (addToCartBtn) addToCartBtn.style.display = '';
      if (buyNowBtn) buyNowBtn.style.display = '';
      if (stickyATC) stickyATC.style.display = '';
      if (quoteBtn) quoteBtn.style.display = 'none';
    }
  }

  document.body.addEventListener('click', function (e) {
    if (
      e.target.matches('[name="plus"], [name="minus"], .qty-plus, .qty-minus') ||
      e.target.closest('.quantity-selector')
    ) {
      setTimeout(toggleButtons, 50);
    }
  });

  document.body.addEventListener('change', function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      toggleButtons();
    }
  });

  toggleButtons();
});

// Block sticky ATC over max qty
document.addEventListener('click', function (e) {
  const qtyInput = document.querySelector('input[name="quantity"]');
  if (!qtyInput) return;

  const qty = parseInt(qtyInput.value || 1);

  if (qty > 5 && e.target.closest('.sticky-atc, .sticky-add-to-cart, [data-sticky-atc]')) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }
});